import { decorate, extendObservable, computed } from "mobx";
import Core from "Core";
import moment from "moment";

export class LicenseInUse extends Core.Stores.Model {
  constructor(store, id) {
    super(store, id);

    extendObservable(this, {
      LicenseId: null,
      UserId: null,
      SessionId: null,
      StartDate: null,
      EndDate: null,
      Offline: null
    });
  }

  get asJSON() {
    return {
      Id: this.Id,
      LicenseId: this.LicenseId,
      UserId: this.UserId,
      SessionId: this.SessionId,
      StartDate: this.StartDate instanceof moment ? this.StartDate.format() : null,
      EndDate: this.EndDate instanceof moment ? this.EndDate.format() : null,
      Offline: this.Offline,
      LastUpdated: this.LastUpdated
    };
  }

  parseAsDate(key) {
    return key.startsWith("Date") || key.endsWith("Date");
  }
}

decorate(LicenseInUse, {
  asJSON: computed
});



// WEBPACK FOOTER //
// ./src/Stores/DataStore/Models/LicenseInUse.js